import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type fetchOpinionModel = {
  id: string | number
}

export const fetchOpinion = ({ id }: fetchOpinionModel) => {
  return new PsychologicalDocumentsUseCase(
    `/parecer/load/${id}`,
    makeAxiosHttpClient()
  )
}
export const resetOpinion = ({ id }: fetchOpinionModel) => {
  return new PsychologicalDocumentsUseCase(
    `/parecer/reset/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveOpinion = ({ id }: fetchOpinionModel) => {
  return new PsychologicalDocumentsUseCase(
    `/parecer/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateOpinion = ({ id }: fetchOpinionModel) => {
  return new PsychologicalDocumentsUseCase(
    `/parecer/update/${id}`,
    makeAxiosHttpClient()
  )
}
